import { FC } from 'react';
import { css } from '@emotion/react';
import { useTranslation } from '@frontend/i18n';
import { theme } from '@frontend/theme';
import { Text } from '@frontend/design-system';

export const ChatWelcomeMessage: FC = () => {
  const { t } = useTranslation('aiOnboarding');
  return (
    <div css={styles.container}>
      <Text weight='bold' size='large'>
        {t("Hi, I'm your AI guide to all things Weave!")}
      </Text>
      <Text size='medium'>{t("I'm here to help you get started.")}</Text>
    </div>
  );
};

const styles = {
  container: css`
    display: flex;
    flex-direction: column;
    gap: ${theme.spacing(2)};
    padding: ${theme.spacing(0, 2)};
  `,
};
